<script setup lang="ts">
import {computed, type PropType, ref} from 'vue';
import {ElInput, ElInputNumber, ElOption, ElSelect} from 'element-plus';
import {CabFinancieleRegel, CabOrganization, FinancieleCategorieEnum, FinancieleCategorieEnum_name, uuidOf} from 'common';
import {FINANCIELE_REGEL_CHANGE_EMIT, FINANCIELE_REGEL_REMOVE_EMIT} from '@/base/cabConstants';
import DeleteButton from '@/views/icons/DeleteIcon.vue';

const emits = defineEmits([FINANCIELE_REGEL_REMOVE_EMIT, FINANCIELE_REGEL_CHANGE_EMIT]);
const props = defineProps({
    regel: {
        type    : Object as PropType<CabFinancieleRegel>,
        required: true,
    },
    allOrganizations: {
        type    : Array as PropType<CabOrganization[]>,
        required: true,
    },
});

const regel          = ref<CabFinancieleRegel>(props.regel);
const organizationId = computed<string | undefined>({
    get: () => regel.value.organization[0] ? uuidOf(regel.value.organization[0]) : undefined,
    set: (id: string | undefined) => {
        const org: CabOrganization | undefined = props.allOrganizations.find(o => uuidOf(o) === id);
        regel.value.organization               = org ? [org] : [];
        onChange();
    },
});

function onChange() {
    emits(FINANCIELE_REGEL_CHANGE_EMIT, regel.value);
}

function onDelete() {
    emits(FINANCIELE_REGEL_REMOVE_EMIT, regel.value);
}
</script>

<template>
    <div class="flex flex-row items-center gap-2 w-full font-medium m-0.5 p-1 bg-yellow-100 text-gray-900">
        <el-select v-model="organizationId" placeholder="organisatie" class="w-44" filterable clearable>
            <el-option v-for="o in allOrganizations" :key="uuidOf(o)" :value="uuidOf(o)" :label="o.name"/>
        </el-select>
        <el-input v-model="regel.kwartaal" placeholder="YYYY-Qn" class="w-24" @change="onChange"/>
        <el-input v-model="regel.thema" placeholder="thema" class="w-40" @change="onChange"/>
        <el-input v-model="regel.kostenpost" placeholder="kostenpost" class="w-48" @change="onChange"/>
        <el-select v-model="regel.categorie" placeholder="categorie" class="w-36" @change="onChange">
            <el-option v-for="c in Object.values(FinancieleCategorieEnum)" :key="c" :value="c" :label="FinancieleCategorieEnum_name(c)"/>
        </el-select>
        <el-input-number v-model="regel.bedrag" :controls="false" :precision="0" class="w-32" title="bedrag (EUR)" @change="onChange"/>
        <div class="flex-1"/>
        <DeleteButton @click="onDelete()"/>
    </div>
</template>
